import BoxBody from 'components/BoxBody.jsx';
import DropZoneModal from 'components/DropZoneModal.jsx';
import Group from 'entities/Group';
import Organization from 'entities/Organization';
import FileSenderMixin from 'components/mixins/FileSenderMixin';
import React from 'react';
import TabPanel from 'components/TabPanel.jsx';
import { getAPIURL } from 'lib/apiRequest';
import TeacherAddUploadTabInitial from './TeacherAddUploadTabInitial.jsx';
import TeacherAddUploadTabSuccess from './TeacherAddUploadTabSuccess.jsx';
import TeacherAddUploadTabUploading from './TeacherAddUploadTabUploading.jsx';
import TeacherAddUploadTabFixErrors from './TeacherAddUploadTabFixErrors.jsx';
import { queryDirectAddJob } from 'groups/lib/directAdd';
import EventTracking from 'lib/EventTracking';

import './styles/TeacherAddUploadTab.scss';

const EVENT_SCREEN_NAME = 'TeacherAddUploadTab';

const TeacherAddUploadTab = React.createClass({
  propTypes: {
    group: React.PropTypes.instanceOf(Group).isRequired,
    organization: React.PropTypes.instanceOf(Organization).isRequired,
    title: React.PropTypes.node.isRequired,
  },

  childContextTypes: {
    eventScreenName: React.PropTypes.string,
  },

  mixins: [
    FileSenderMixin,
  ],

  getInitialState() {
    return {
      composerExpanded: false,
      fileUploaded: false,
      error: null,
      fixingErrors: false,
    };
  },

  getChildContext() {
    return {
      eventScreenName: EVENT_SCREEN_NAME,
    };
  },

  componentDidMount() {
    EventTracking.view(EVENT_SCREEN_NAME);
  },

  componentWillUnmount() {
    this.getFiles().map(this.removeFile);
  },

  onDragEnter() {
    if (!this.state.composerExpanded) {
      this.onDragOverDropzone();
    }
  },

  onDragOverDropzone() {
    if (!this.state.composerExpanded) {
      this.setState({ composerExpanded: true, isDraggingFileInner: true });
    }
  },

  onDragOverWindow() {
    if (!this.state.composerExpanded) {
      this.setState({ composerExpanded: true });
    }
  },

  onUploadFailed(file, error) {
    this.removeAllFiles();
    this.setState({ error });
  },

  onUploadSuccess(file) {
    this.removeAllFiles();
    const response = JSON.parse(file.xhr.response);
    this.setState({
      fileUploaded: true,
      error: null,
      uploadProcessing: true,
      uploadPercentage: 0,
    });

    queryDirectAddJob(this.props.organization.id, response.id, (pollResponse) => {
      this.setState({
        uploadPercentage: Math.floor(100 * (pollResponse.completed / pollResponse.total)),
      });
    }).then((results) => setTimeout(
      () => this.setState({ uploadProcessing: false, successResponse: results }),
      500, // CSS transition duration for the progress bar
    )).catch(e => console.error('TeacherAddUploadTab queryDirectAddJob failed', e));
  },

  onAddedFile() {
    this.setState({ fileUploaded: false });
  },

  getUploadURL() {
    return getAPIURL(`/organizations/${this.props.organization.id}/${this._role}/spreadsheet`);
  },

  getDropzoneId() {
    return this.props.organization.id;
  },

  isFileUploaded() {
    return this.getFiles().length > 0 && this.getFiles()[0].status === 'success';
  },

  resetTab() {
    if (this.state.fileUploaded || this.state.fixingErrors) {
      this.destroyDropzoneIfEmpty();
      this.setState(this.getInitialState());
    }
  },

  renderDropzoneModal() {
    if (this.state.isDraggingFile) {
      return (
        <DropZoneModal
          isFileUploaded={this.getFiles().length > 0}
          isHovering={this.state.isDraggingFileInner}
          title="Drag and drop spreadsheet to upload"
          titleDrop="Drop spreadsheet!"
        />
      );
    }
    return null;
  },

  renderContent() {
    if (this.state.uploadProcessing) {
      return <TeacherAddUploadTabUploading uploadPercentage={this.state.uploadPercentage} />;
    }
    if (this.state.fixingErrors) {
      const users = this.state.successResponse.errorUsers;
      return (
        <TeacherAddUploadTabFixErrors
          organization={this.props.organization}
          users={users}
          role={this._role}
          onSuccess={response => this.setState({ fixingErrors: false, successResponse: response })}
        />
      );
    }
    if (this.state.successResponse) {
      return (
        <div ref="dropzone_attach">
          <TeacherAddUploadTabSuccess
            group={this.props.group}
            role={this._role}
            response={this.state.successResponse}
            onFixError={() => this.setState({ fixingErrors: true })}
          />
        </div>
      );
    }
    return (
      <div ref="dropzone_attach">
        <TeacherAddUploadTabInitial
          dropzoneid={this.getDropzoneId()}
          setRole={role => { this._role = role; }}
          error={this.state.error}
        />
      </div>
    );
  },

  render() {
    return (
      <TabPanel
        selectedBorderColor="brand"
        className="TeacherAddUploadTab-panel TeacherAddUploadTab-link"
        title={this.props.title}>
        <BoxBody
          ref="dropzone"
          className="TeacherAddUploadTab-box"
          onDragEnter={this.onDragEnter}>
          {this.renderDropzoneModal()}
          {this.renderContent()}
        </BoxBody>
      </TabPanel>
    );
  },
});

export default TeacherAddUploadTab;



// WEBPACK FOOTER //
// ./src/groups/components/TeacherAddUploadTab.jsx